import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';
import logo_img from '../img/housekaar_logo.avif';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  return (
    <header className=''>
      <nav className="nav">
        <div className="whatsapp-icon-nav">
          <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer" aria-label="Contact us on WhatsApp">
            <FaWhatsapp size={40} color="#25D366" />
            <span class="sr-only">Contact us on WhatsApp</span>
          </a>
        </div>
        <div className="logo">
          <Link to="/" style={{display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit'}}>
              <img
                src={logo_img}
                alt="Housekaar Logo"
              />
          </Link>
        </div>
        <div className="hamburger" onClick={handleToggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
        <ul id="nav-list" className={isMenuOpen ? 'active' : ''}>
          <li>
            <Link to="/house-plans">House Plan</Link>
          </li>
          <li>
            <Link to="/services">Services</Link>
          </li>
          <li>
            <Link to="/projects">Projects</Link>
          </li>
          <li>
            <Link to="/floor-plans">Floor Plan</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;